export default "__VITE_ASSET__3e97cdbf__"